import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from "./store"


import less from 'less'
Vue.use(less)

import Calendar from 'vue-mobile-calendar'
Vue.use(Calendar);

import Meta from 'vue-meta';
// 使用vue-meta
Vue.use(Meta);
// 引用jquery
// import $ from 'jquery'
// Vue.prototype.JQ = $

import moment from 'moment'
//定义一个全局过滤器实现日期格式化
Vue.filter('datefmt', function(input, fmtstring) { //当input为时间戳时，需转为Number类型
    // 使用momentjs这个日期格式化类库实现日期的格式化功能
    return moment(input).format(fmtstring);
});
Vue.prototype.$moment = moment

// swiper切换
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/css/swiper.css";
Vue.use(VueAwesomeSwiper);
// 标签名修改
Vue.directive('title', {
    inserted: function(el) {
        document.title = el.dataset.title
    }
})

import $ from 'jquery'
Vue.prototype.$ = $;

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import Mint from 'mint-ui';
import 'mint-ui/lib/style.css'
Vue.use(Mint);

Vue.config.productionTip = false
Vue.use(ElementUI)



new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')